import React, { useEffect, useState } from "react";
import { getData } from "../../../../services/library";
import { Divider, Box, Stack, Chip, Typography, Paper } from '@mui/material';
import { CommentOutlined } from '@mui/icons-material';
// import { Box, Stack, Typography, Divider } from '@mui/material';
import { ChatBubbleOutlineRounded } from '@mui/icons-material';
import { ScaleOutlined } from "@mui/icons-material";
import { useFetcher } from "react-router-dom";

// export default function DetailPanelPedido({ row }) {
    export default function DetailPanelPedido({row, updateData, setUpdateData}) {
    const pedido = row.original;
    const [obsHist, setObsHist] = useState([]);

    useEffect(()=>{
        getData(`/pedidos_obs_historial/id_pedido/${pedido.id}`, setObsHist)
    },[])

    useEffect(()=>{
        if (!!updateData){
            getData(`/pedidos_obs_historial/id_pedido/${pedido.id}`, setObsHist)
            setUpdateData(!updateData)
        }
    },[updateData])

    return (
        <div>
            <Box
                sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'grey.50',
                    border: '1px solid',
                    borderColor: 'grey.200',
                }}
            >
                <Stack direction="row" spacing={3} alignItems="flex-start">
                    <Box>
                        <Typography variant="caption" color="primary">
                            Cantidad
                        </Typography>
                        <Stack direction="row" alignItems="baseline" spacing={0.5}>
                            <Chip
                                label={pedido?.cantidad ? `${pedido?.cantidad} KGS` : `${pedido?.porcentaje} %`}
                                color="primary"
                                sx={{
                                    fontSize: '0.95rem',
                                    fontWeight: 600,
                                    py: 2,
                                    px: 0.5,
                                }}
                            />
                        </Stack>
                    </Box>
                    {obsHist?.length > 0 && (
                        <>
                            <Divider orientation="vertical" flexItem />
                            <Box sx={{ flex: 1 }}>
                                <Stack direction="row" alignItems="center" spacing={0.5} mb={0.5}>
                                    <ChatBubbleOutlineRounded sx={{ fontSize: 18}} color="primary" />
                                    <Typography variant="caption" color="primary">
                                        Última observación:
                                    </Typography>
                                </Stack>
                                <Typography variant="body2">
                                    {obsHist[obsHist.length - 1].observacion}
                                </Typography>
                            </Box>
                        </>
                    )}
                    {
                        obsHist?.length === 0 && pedido?.observaciones && (
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {pedido?.observaciones}
                                </Typography>
                            </Box>
                        )
                    }
                    {
                        obsHist?.length===0 && !pedido?.observaciones && (
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" color="text.secondary">
                                    No hay observaciones para este pedido.
                                </Typography>
                            </Box>
                        )
                    }
                </Stack>
            </Box>
        </div>
    );
}